import { useState } from 'react';
import { useAppDispatch } from 'core/store/hooks';
import { CloseEconomicsProjectRequest } from '@api/client';
import { closeEconomicsCl } from '../_redux/actions';
import { closeRendicontazione } from '../../project-list/project-detail/_redux/actions';
import { AppToastService } from 'shared/design-system/components/app-toast/app-toast.service';
import { useTranslation } from 'react-i18next';

const useCloseAll = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showConfirmCloseAllModal, setShowConfirmCloseAllModal] = useState(false);
  const [idToCloseAll, setIdToCloseAll] = useState<number | null>(null);

  const closeAll = async () => {
    setShowConfirmCloseAllModal(false);

    if (!idToCloseAll) return;

    try {
      // Step 1: Close Reporting
      await dispatch(closeRendicontazione(idToCloseAll)).unwrap();

      // Step 2: Close Economics (solo se step 1 ha successo)
      const payload: CloseEconomicsProjectRequest = {
        projectId: idToCloseAll,
      };
      await dispatch(closeEconomicsCl(payload)).unwrap();

      AppToastService.success(t('common.action-completed-successfully'));
    } catch (error) {
      // Se fallisce, l'errore è già gestito da errorHandler nelle actions
    }
  };

  return {
    closeAll,
    showConfirmCloseAllModal,
    setShowConfirmCloseAllModal,
    idToCloseAll,
    setIdToCloseAll,
  };
};

export default useCloseAll;
